import { type ReactNode } from 'react';
import ItemCollectionContainer, {
	type ItemCollectionContainerProps,
} from '../item-collection-container';

const GridContainer = ({
	as = 'div',
	gap = 'var(--spacing-xxs)',
	columns = 3,
	columnWidth = null, // ColumnWidth overrides column count
	shelfOnMobile = false,
	autoSizedShelfVisibleItemCount = 2,
	className,
	children,
}: IProps) => {
	return (
		<ItemCollectionContainer
			type={shelfOnMobile ? 'grelf' : 'grid'}
			gap={gap}
			as={as}
			gridOptions={{
				columnWidth,
				columns,
				hasClampedWidth: shelfOnMobile,
			}}
			shelfOptions={{
				autoSizeItems: true,
				autoSizedVisibleItemCount: autoSizedShelfVisibleItemCount,
			}}
			className={className}
		>
			{children}
		</ItemCollectionContainer>
	);
};

type GridOptions = ItemCollectionContainerProps['gridOptions'];
type ShelfOptions = ItemCollectionContainerProps['shelfOptions'];

export interface IProps {
	as?: ItemCollectionContainerProps['as'];
	gap?: ItemCollectionContainerProps['gap'];
	columnWidth?: GridOptions['columnWidth'];
	columns?: GridOptions['columns'];
	autoSizedShelfVisibleItemCount?: ShelfOptions['autoSizedVisibleItemCount'];
	shelfOnMobile?: boolean;
	className?: ItemCollectionContainerProps['className'];
	children: ReactNode;
}

export default GridContainer;
